import { useMemo } from 'react';

import type { GameplayTier } from '#src/__generated__/globalTypes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';

export const useGameplayTierRatings = () => {
  const {
    baseballGameplayTierRatings,
    footballGameplayTierRatings,
    nbaGameplayTierRatings,
  } = useConfigContext();

  return useMemo(() => {
    const starsByTier = new Map(
      [
        ...baseballGameplayTierRatings,
        ...footballGameplayTierRatings,
        ...nbaGameplayTierRatings,
      ].map(({ gameplayTier, stars }) => [gameplayTier, stars])
    );
    const nbaStars = nbaGameplayTierRatings.map(({ stars }) => stars);

    return {
      starsOf: (gameplayTier: Nullable<GameplayTier>) =>
        gameplayTier ? starsByTier.get(gameplayTier) : undefined,
      nba: {
        minStars: Math.min(...nbaStars),
        maxStars: Math.max(...nbaStars),
        gameplayTierFromStars: (stars: number) =>
          nbaGameplayTierRatings.find(rating => rating.stars === stars)
            ?.gameplayTier,
      },
    };
  }, [
    baseballGameplayTierRatings,
    footballGameplayTierRatings,
    nbaGameplayTierRatings,
  ]);
};
